<template>
  <div>
    <div
      v-if="numberIpt > 0 && !isIpt && !loading && !getProcessingEmployees"
      class=""
    >
      <p>
        Selecciona <strong>({{ numberIpt }})</strong> persona(s) para las IPT
        requeridas por GES.
      </p>
      <div class="d-flex justify-content-start">
        <button
          class="button-primary"
          :disabled="isDisabled"
          @click.prevent="saveSelected"
        >
          <span
            >Guardar selección
            <img class="pl-1 mb-1" src="@/assets/images/icons/save-white.svg" />
          </span>
        </button>
      </div>
    </div>
    <div>
      <b-table
        :fields="fields"
        :busy="getProcessingEmployees"
        :items="getEmployeesGES.data"
        selectable
        @row-selected="onRowSelected"
        ref="selectableTable"
        class="col-12 mt-5 p-0 table-view-employees"
        selected-variant="warning"
        show-empty
      >
        <template #cell(name)="row">
          {{ row.item.name }}<br />
          <b>c.c. {{ row.item.cc }}</b>
        </template>
        <template #table-busy>
          <div class="text-center my-2 mb-3">
            <OverlayButton clase="overlay-md"></OverlayButton>
          </div>
        </template>
        <!-- <template #cell(selected)="row" v-if="numberIpt > 0">
          <div
            class="d-flex justify-content-center align-items-center"
            style="height: 30px"
          >
            <input type="checkbox" :checked="row.item.isSelected" disabled />
          </div>
        </template> -->
        <template #empty>
          <div class="text-center my-2">
            <h2>Sin datos para mostrar</h2>
          </div>
        </template>
      </b-table>
      <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
        <Pagination
          :data="getEmployeesGES"
          :limit="10"
          @pagination-change-page="paginateEmployeeGES"
        >
        </Pagination>
      </div>
    </div>
    <ModalSavePersonIPTRequired
      :selected="itemsSelected().selecteds"
      v-if="!isDisabled"
      @savePersonIpt="() => $emit('savePersonIpt')"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
import ModalSavePersonIPTRequired from "../../modals/ModalSavePersonIPTRequired.vue";

export default {
  props: {
    ges: {
      type: Object,
      default: () => {},
    },
    isIpt: {
      type: Boolean,
      default: false,
    },
    numberIpt: {
      type: Number,
      default: 0,
    },
  },
  components: {
    OverlayButton,
    Pagination,
    ModalSavePersonIPTRequired,
  },
  data() {
    return {
      fields: [
        {
          key: "selected",
          label: "",
        },
        {
          key: "name",
          label: "Nombre / C.C",
          sortable: true,
        },
        {
          key: "charge",
          label: "Cargo",
          sortable: true,
        },
        {
          key: "area",
          label: "Área",
          sortable: true,
        },
        {
          key: "health_condition",
          label: "Condición de salud",
          sortable: true,
        },
        {
          key: "option",
          label: "",
        },
      ],
      selected: [],
      page: 1,
    };
  },
  watch: {
    "getEmployeesGES.data"() {
      const me = this;
      if (me.selected.length > 0 && !me.getProcessingEmployees) {
        const record = me.selected.find((y) => y.page === me.page);
        if (record) {
          me.getEmployeesGES.data.forEach((x) => {
            if (record.data.some((y) => y.id === x.id)) {
              x.isSelected = true;
            }
          });
          me.updateSelectedEmployees(me.getEmployeesGES.data);
          me.selectRows();
        }
      }
    },
  },
  computed: {
    ...mapGetters("htGes", ["getProcessingEmployees", "getEmployeesGES"]),
    ...mapState("modSVE", ["loading"]),
    isDisabled() {
      const me = this;
      return me.selected.length > 0 ? false : true;
      // if (me.itemsSelected().total === me.numberIpt) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
  },
  methods: {
    ...mapActions("htGes", [
      "indexEmployee",
      "updateSelectedEmployees",
      "updateStateEmployee",
    ]),
    onRowSelected(items) {
      const me = this;
      if (!me.getProcessingEmployees) {
        if (me.numberIpt == 0 || me.isIpt) {
          me.getEmployeesGES.data.forEach((x, index) => {
            if (!x.isSelected) me.$refs.selectableTable.unselectRow(index);
          });
        } else {
          if (me.numberIpt > 0 && me.itemsSelected().total < me.numberIpt) {
            me.getEmployeesGES.data.forEach((x) => {
              x.isSelected = items.some((y) => y.id === x.id);
            });
          } else {
            me.getEmployeesGES.data.forEach((x, index) => {
              const record = me.selected.find((y) => y.page === me.page);
              if (
                record.data.some((y) => y.id === x.id) &&
                !items.some((y) => y.id === x.id)
              ) {
                x.isSelected = false;
                me.$refs.selectableTable.unselectRow(index);
              }
            });
          }

          if (me.numberIpt > 0 && items.length > me.numberIpt) {
            me.getEmployeesGES.data.forEach((x, index) => {
              if (!x.isSelected) me.$refs.selectableTable.unselectRow(index);
            });
          }

          me.updateSelectedEmployees(me.getEmployeesGES.data);
          me.loadSelected(me.getEmployeesGES.data);
        }
      }
    },
    loadSelected(items) {
      const me = this;
      if (!me.getProcessingEmployees) {
        const record = me.selected.find((y) => y.page === me.page);

        if (record) {
          record.data = items.filter((x) => x.isSelected);
        } else {
          me.selected.push({
            page: me.page,
            data: items.filter((x) => x.isSelected),
          });
        }
      }
    },
    saveSelected() {
      const me = this;
      me.$bvModal.show("modal-save-person-ipt-required");
    },
    selectRows() {
      const me = this;
      me.$nextTick(() => {
        me.getEmployeesGES.data.forEach((x, index) => {
          if (x.isSelected) {
            me.$refs.selectableTable.selectRow(index);
          }
        });
      });
    },
    itemsSelected() {
      const me = this;
      const selecteds = [];
      me.selected.forEach((x) => {
        x.data.forEach((y) => {
          selecteds.push(y);
        });
      });

      return {
        selecteds,
        total: selecteds.length,
      };
    },
    paginateEmployeeGES(page = 1) {
      const me = this;
      me.page = page;
      me.indexEmployee({ id: me.ges.id, values: { page } });
    },
  },
};
</script>

<style lang="scss">
.table-view-employees {
  box-shadow: 0 0 4px 2px transparent !important;
  border-radius: 0 !important;
}
.table-view-employees thead {
  border-radius: 0 !important;
  border: none !important;
}

.table-view-employees thead tr th:first-child {
  width: 40px !important;
}

.table-view-employees tbody tr td:first-child {
  width: 40px !important;
}

.table-view-employees thead th:first-child {
  border-radius: 0px !important;
}

.table-view-employees thead th:last-child {
  border-radius: 0px !important;
}

.table-view-employees thead th {
  border-bottom: none !important;
}

.table-view-employees .table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #e3e4fc !important;
  border: none !important;
}

/* .table-view-employees tr td {
  background-color: transparent !important;
} */
</style>
